module.exports = __webpack_public_path__ + "static/media/24.1bdbb5b5.svg";